var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.miniProgramCustomer
        ? [
            _vm.checkPermi(["admin:statistics:home:index"])
              ? _c("base-info", { ref: "baseInfo" })
              : _vm._e(),
            _vm._v(" "),
            _c("grid-menu", { staticClass: "mb20" }),
            _vm._v(" "),
            _c("user-overview"),
            _vm._v(" "),
            _c("visit-chart", { ref: "visitChart" }),
            _vm._v(" "),
            _vm.checkPermi(["admin:statistics:home:chart:user"])
              ? _c("user-chart", { ref: "userChart", staticClass: "mb20" })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkPermi(["admin:statistics:home:chart:user"])
              ? _c("userFuka", { ref: "userFukaChart", staticClass: "mb20" })
              : _vm._e(),
          ]
        : [
            _vm.checkPermi(["admin:statistics:home:chart:user"])
              ? _c("userFuka", {
                  ref: "userFukaChart",
                  staticClass: "mb20",
                  attrs: {
                    miniProgramCustomer: _vm.miniProgramCustomer,
                    defaultCustomerId: _vm.defaultCustomerId,
                  },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }